import { universalSearchResultItem, universalSearchType } from "Store/UniversalSearchStore";
import { useCallback, useEffect, useState } from "react";

import { useRootStore } from "Store/RootStore";
import { useSearchParams } from "react-router";

const emptyResult: Promise<universalSearchResultItem[]> = Promise.resolve([]);
export const useUniversalSearch = (
    id: string,
    target: string | undefined,
    onSearch?: (word: string) => Promise<universalSearchResultItem[]>,
    syncWithUrl?: boolean,
    appPath?: string
) => {
    const searchStore = useRootStore("UniversalSearchStore");
    const [search, setSearch] = useState<universalSearchType>();
    const [searchParams, setSearchparams] = useSearchParams();

    const onSearchWrapper = useCallback(
        (word: string) => {
            if (syncWithUrl) {
                setSearchparams((prev) => {
                    prev.set("search", word);
                    return prev;
                });
            }
            return onSearch ? onSearch(word) : emptyResult;
        },
        [onSearch, setSearchparams, syncWithUrl]
    );

    useEffect(() => {
        if (!target) {
            return;
        }
        setSearch(searchStore.subscribe(id, target, appPath));
        const searchWord = searchParams.get("search");
        if (searchWord) {
            searchStore.onSearch(searchWord);
        }
        return () => {
            searchStore.unSubscribe(id);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        search?.setOnSearch(onSearchWrapper);
    }, [onSearchWrapper, search]);

    return {
        searchWord: target && !searchStore.isGlobalSearch ? searchStore.searchWord : ""
    };
};
